import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Import all candidate components
import CandidateSidebar from '../components/candidate/sidebar/CandidateSidebar';
import PersonalInfo from '../components/candidate/personal-info/personal-info';
import AddressInfo from '../components/candidate/address-info/AddressInfo';
import EducationStepper from '../components/candidate/education-info/EducationStepper';
import EmploymentDetails from '../components/candidate/employment-info/EmploymentDetails';
import Declaration from '../components/candidate/declaration/Declaration';
import Instructions from '../components/candidate/instructions/Instructions';
import NewEmployement from '../components/candidate/employment-info/NewEmployement';
import EditEmployeement from '../components/candidate/employment-info/EditEmployeement';
import CandidateDashboard from '../components/candidate/CandidateDashboard/candidate-Dashboard';
import CandidateChatbot from '../components/candidate/chatbot/CandidateChatbot';
import DigiLockerVerification from '../components/candidate/digilockerrouter/DigiLockerVerification';

const CandidateRoutes = () => {
  const location = useLocation();
  const [isSidebarDisabled, setIsSidebarDisabled] = useState(false);

  useEffect(() => {
    // Disable the sidebar when on Instructions, CandidateDashboard, or DigiLockerVerification pages
    setIsSidebarDisabled(
      location.pathname === '/candidate/dashboard' ||
      location.pathname === '/candidate/candidate-dashboard' ||
      location.pathname === '/candidate/digilocker-router'
    );
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<CandidateSidebar isSidebarDisabled={isSidebarDisabled} />}>
        <Route index element={<Navigate to="dashboard" />} />
        <Route path='candidate-dashboard' element={<CandidateDashboard/>} />
        <Route path="dashboard" element={<Instructions />} />
        <Route path="personal-info" element={<PersonalInfo />} />
        <Route path="address-info" element={<AddressInfo />} />
        <Route path="education-info" element={<EducationStepper />} />
        <Route path="employment-info" element={<EmploymentDetails />} />
        <Route path='new-employment' element={<NewEmployement />} />
        <Route path='edit-employment/:id' element={<EditEmployeement/>} />
        <Route path="declaration" element={<Declaration />} />
        <Route path="chatbot" element={<CandidateChatbot />} />
        <Route path="digilocker-router" element={<DigiLockerVerification />} />
      </Route>
    </Routes>
  );
};
  
export default CandidateRoutes;